@if (dropdown) {
    <button mat-menu-item [attr.aria-label]="buttonName() || buttonDescription()" (click)="buttonClick()" color="primary" [matMenuTriggerFor]="triggerFor" [disabled]="isDisabled()">
        <span class="material-symbols-outlined" style="padding-right:10px;">
            {{getIcon()}}
        </span>    
        <span>{{buttonName()}}</span>
    </button>
}@else {    
    <button mat-icon-button [matTooltip]="buttonName()" [attr.aria-label]="buttonName() || buttonDescription()" (click)="buttonClick()" color="primary" [matMenuTriggerFor]="triggerFor" [disabled]="isDisabled()" [style]="isHighlight()">
        <span class="material-symbols-outlined">
            {{getIcon()}}
        </span>    
    </button>
}